import { createContext } from "react";

const CopyContext = createContext(null);

export default CopyContext;
